let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kwiXK")).then(() => parcelRequire('iPt4B'));